import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Formik, Form, Field, getIn } from "formik";
import styled from "styled-components";
import { Alert } from "react-bootstrap";
import { Redirect } from "react-router-dom";

//Store
import { authActions } from "../../../../store/modules/auth";

//Global Components
import Aux from "../../../hoc/_Aux";
import Breadcrumb from "../../../layout/AdminLayout/Breadcrumb";
import Logo from "./../../../../assets/images/logo-colypro-main.png";
import Spinner from "../../../components/Spinner";

//Page Components
import ValidationMessage from "./Components/validationMessage";

//Global Styles
import "./../../../../assets/scss/style.scss";

function getStyles(errors, fieldName) {
  if (getIn(errors, fieldName)) {
    return {
      border: "1px solid red",
    };
  }
}

const validateEmail = (value) => {
  let error;
  if (!value) {
    error = "Campo requerido";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = "Correo electrónico inválido";
  }
  return error;
};

const validatePassword = (value) => {
  let error;
  if (!value) {
    error = "Campo requerido";
  }
  return error;
};

const validateCarnetNumber = (value) => {
  let error;
  if (!value) {
    error = "Campo requerido";
  }
  return error;
};

const InvalidAcessAlert = styled(Alert)`
  padding: 10px !important;
  background-color: #e66c1f !important;
  border-color: #e66c1f !important;
  border-radius: 0.25rem !important;
  color: #fff !important;
`;

const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  input{
    margin-right: 5px;
  }
`

class SignIn extends React.Component {
  constructor() {
    super();
    this.handleLogin = this.handleLogin.bind(this); 
  }
  state={
    labelSelected: false,
  }

  handleLogin(values) {
    this.props.requestLogin();
    this.props.login(values);
  }

  onLabelChange=(value)=>{
    this.setState({
      labelSelected: value
    })
  }

  render() {
    const { isAuthenticated, isFailure, isLoading, roles, message } = this.props;

    const submitText = isLoading ? "Iniciando sesión" : "Iniciar sesión";
    const selectText = "Seleccionar Rol";
    return !isAuthenticated ? (
      <Aux>
        <Breadcrumb />
        <div className="auth-wrapper">
          <div className="auth-content">
            {/* <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div> */}
            <div className="card">
            <div class="card-header text-center " style={{backgroundColor: "#014D8A"}}>
              <h4 class="mb-0 text-white font-weight-bold"> SISTEMA DE RESERVACIONES </h4>
                
            </div>
              <div className="card-body text-center" >
                <h3 className="mb-4">
                  <img src={Logo} style={{ width: "50%" }} alt="Logo" />
                </h3>
                
                {isFailure ? (
                  <InvalidAcessAlert variant="danger">
                    {message}
                  </InvalidAcessAlert>
                ) : null}
                {!roles ? (
                  <Formik
                    initialValues={{
                      identityNumber: "",
                      password: "",
                    }}
                    onSubmit={async (values) => {
                      this.handleLogin(values);
                    }}
                  >
                    {({ errors, touched, isValidating }) => (
                      <Form>
                        <div className="input-group mb-3">
                          <Field
                            id="identityNumber"
                            name="identityNumber"
                            type="text"
                            className="form-control"
                            placeholder="Cédula"
                            disabled={isLoading}
                            validate={validateCarnetNumber}
                            style={getStyles(errors, "carnetNumber")}
                          />
                          {errors.identityNumber && touched.identityNumber && (
                            <ValidationMessage message={errors.identityNumber} />
                          )}
                        </div>
                        <div className="input-group mb-4">
                          <Field
                            id="password"
                            name="password"
                            type="password"
                            className="form-control"
                            placeholder="Contraseña"
                            disabled={isLoading}
                            style={getStyles(errors, "password")}
                          />
                          {errors.password && touched.password && (
                            <ValidationMessage message={errors.password} />
                          )} 
                        </div>
                        <button
                          type="submit"
                          className="btn btn-secondary shadow-2 mb-4 mr-0"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spinner /> : null}
                          {submitText}
                        </button>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <>
                    <p>
                      El usuario posee varios roles asignados, seleccione un rol
                      para acceder al sistema.
                    </p>
                    <Formik
                      initialValues={{
                        role: ""
                      }}
               
                      onSubmit={async (values) => {
                        this.props.setRole(values.role);
                      }}

                    >
                      {({ errors, touched, isValidating }) => (
                        <Form onChange={()=>this.onLabelChange(true)}>
                          <div className="input-group mb-3 shadow-none p-3 bg-light rounded">
                          <RadioGroup>
                              {roles.map((role) =>{
                                return (
                                  <label key={role.rolId}>
                                    {" "}
                                  <Field type="radio" name="role" value={role.name} />
                                  {role.name}
                                </label>
                                )
                              })}
                            </RadioGroup>

                          </div>

                          <button
                            type="submit"
                            className="btn btn-secondary shadow-2 mb-4 mr-0"
                            disabled={!this.state.labelSelected}
                          >
                            {isLoading ? <Spinner /> : null}
                            {selectText}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Aux>
    ) : (
      <Redirect to={{ pathname: "/" }} />
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.authState.auth,
    isAuthenticated: state.authState.auth.isAuthenticated,
    isFailure: state.authState.auth.isFailure,
    isLoading: state.authState.auth.isLoading,
    roles: state.authState.auth.roles,
    message: state.authState.auth.message
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestLogin: authActions.requestLogin,
      login: authActions.login,
      setRole: authActions.setRole,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
